export const FiscalInfo = ({ className = "" }) => (
  <div
    className={`mt-10 p-5 rounded-lg ${className}`}
    data-testid="fiscal-info-block"
    style={{
      backgroundColor: "var(--app-card)",
      border: "1px solid var(--app-border)",
    }}
  >
    <h3 className="text-xs font-bold tracking-widest text-violet-500 dark:text-violet-400 uppercase mb-3">
      Datos del Responsable / Titular del Sitio
    </h3>
    <ul className="text-sm space-y-1.5" style={{ color: "var(--app-text)" }}>
      <li>
        <span style={{ color: "var(--app-text-muted)" }}>Razon social:</span>{" "}
        <span className="font-semibold">ANDRES CARLOS OSTENGO</span>
      </li>
      <li>
        <span style={{ color: "var(--app-text-muted)" }}>CUIT:</span> 20-27575122-8
      </li>
      <li className="leading-relaxed">
        <span style={{ color: "var(--app-text-muted)" }}>Domicilio legal:</span> San Martin 839, Piso 3 Dpto A
        <span className="block text-xs" style={{ color: "var(--app-text-muted)" }}>
          Entre Salta y Junin - San Miguel de Tucuman, Tucuman, Argentina
        </span>
      </li>
      <li>
        <span style={{ color: "var(--app-text-muted)" }}>Email:</span>{" "}
        <a href="mailto:veritelwhat@gmail.com" className="text-violet-500 dark:text-violet-400 hover:underline">
          veritelwhat@gmail.com
        </a>
      </li>
      <li>
        <span style={{ color: "var(--app-text-muted)" }}>WhatsApp:</span>{" "}
        <a href="https://wa.me/5491124510886" target="_blank" rel="noopener noreferrer" className="text-violet-500 dark:text-violet-400 hover:underline">
          +54 9 11 2451-0886
        </a>
      </li>
      <li>
        <span style={{ color: "var(--app-text-muted)" }}>Telefono:</span>{" "}
        <a href="tel:08101228899" className="text-violet-500 dark:text-violet-400 hover:underline">
          0810-122-8899
        </a>
      </li>
    </ul>
  </div>
);
